import parseUrl from 'parse-url';
import buildUrl from 'build-url';
import { ImageResizeConfig } from '../components/Product/productImageResizeConfigs';

const IMAGESERVICE = {
    CROP: {
        PADDING: 'c_pad',
    },
    FULL_PATH_PREFIX: '/image/upload/',
    FORMAT: {
        PNG: 'f_png',
        WEB_P: 'f_webp',
        E_TRIM: 'e_trim',
    },
};

const EXTENSION = '.jpg';
const DEFAULT_IMAGE_SUFFIX = `-look${EXTENSION}`;
const SIMPLE = 'simple';
const PRODUCT = 'product';

const imageRegex = /\/([sp]).*-([0-9]{2})([0-9]+)-((?:[0-9]+|z-)).*$/;

const getParsedUrl = (url: string): { [key: string]: any } => parseUrl(url);
const buildNewUrl = (protocol: string, resource: string, path: string): string =>
    buildUrl(`${protocol}://${resource}`, { path });

// eslint-disable-next-line complexity
const configureSize = (resizeConfig: ImageResizeConfig): string => {
    const { width, height, padding, quality, isTrimmed, paddingSize, webP, isLimited } = resizeConfig;
    const sizeArray = [];
    let pathString = '';
    if (isTrimmed) {
        pathString += `${IMAGESERVICE.FORMAT.E_TRIM}/`;
    }

    if (webP) {
        pathString += IMAGESERVICE.FORMAT.WEB_P;
    }

    if (quality && quality <= 90) {
        pathString += `/q_${quality}`;
    }

    if (padding) {
        sizeArray.push(IMAGESERVICE.CROP.PADDING);
    }

    if (width) {
        sizeArray.push(`w_${width}`);
    }

    if (height) {
        sizeArray.push(`h_${height}`);
    }
    if (paddingSize) {
        sizeArray.push(`pd_${paddingSize.top}_${paddingSize.right}_${paddingSize.bottom}_${paddingSize.left}`);
    }
    if (isLimited) {
        sizeArray.push(`c_limit`);
    }

    if (sizeArray.length > 0) {
        return `${pathString}/${sizeArray.join(',')}`;
    }
    return `${pathString}`;
};

const resizeImage = (url: string, resizeConfig: ImageResizeConfig): string => {
    if (url === '') {
        return '';
    }
    const { protocol, resource, pathname } = getParsedUrl(url);
    const parts = pathname.match(imageRegex);
    if (parts) {
        const [, productType, folder1, folder2, imageFileName] = parts;
        const type = productType === 's' ? SIMPLE : PRODUCT;
        const newPath = `/${type}/${folder1}/${folder2}/${imageFileName}${EXTENSION}`;
        let fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
        fullPath += configureSize(resizeConfig);
        // @todo: let's have a versioning from Bob config, so we can invalidate cache as needed, if needed
        fullPath += `/v1`;
        fullPath += newPath;
        fullPath = fullPath.replace(/\/\//g, '/');
        return buildNewUrl(protocol, resource, fullPath);
    }
    return `${url}${DEFAULT_IMAGE_SUFFIX}`;
};

export const reformatImage = (urlpath: string, staticHost: string, resizeConfig: ImageResizeConfig): string => {
    if (urlpath === '') {
        return '';
    }

    let fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
    fullPath += configureSize(resizeConfig);
    fullPath += `/${urlpath}`;
    fullPath = fullPath.replace(/\/\//g, '/');
    return buildUrl(staticHost, { path: fullPath });
};

export const changePreformattedImageProperties = (preformattedUrl: string, resizeConfig: ImageResizeConfig): string => {
    if (preformattedUrl === '') {
        return '';
    }
    const { protocol, resource, pathname } = getParsedUrl(preformattedUrl);
    const cmsPreformattedPart = pathname.match(/\/cms\/.*/i);
    if (cmsPreformattedPart) {
        let fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
        fullPath += configureSize(resizeConfig);
        fullPath += cmsPreformattedPart;
        fullPath = fullPath.replace(/\/\//g, '/');
        return buildNewUrl(protocol, resource, fullPath);
    }
    return `${preformattedUrl}${DEFAULT_IMAGE_SUFFIX}`;
};

export default resizeImage;
